/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select/index.js';
import InputText from '../InputText/InputText.js';
import { percentage } from '../../../../utils/ValidationUtils';
import './Region.css';

const Region = (props) => {
  const {
    content,
    onChangeAction,
    handleBlurAction
  } = props;

  const selectFieldChange  = (obj, newValue) => {
    /*
    * callback the drop down onChange action.
    */
    onChangeAction && onChangeAction(obj, newValue)
  };

  const defaultOverlapLabel = {
    labelContent: '%',
    float: 'right'
  };

  const handleTextChangeAction = (questionRel, val)=> {
    /*
    * callback input field the onChange action.
    */

    if (percentage(val)) {
      /* check if value is validation */
      onChangeAction && onChangeAction(questionRel, val);
    }
  };

  return (
    <div className="dynamic-group region">
        <Select
          content={ content.selectField }
          onChangeAction={ selectFieldChange }
          defaultValue={ content.selectField.defaultValue }
          validationState={ content.selectField.isError ? 'error' : null }
          hasDelBtn={ false }
          disabled={ content.selectField.isDisabled }
        />
      {
        (content.inputField).map((inputObj, index) => {
          return (
            <div className="reserved-item-input" key={`region_${index}`} data-index={ index }>
                <InputText
                  handleTextChange={ handleTextChangeAction }
                  content={ inputObj }
                  overlapLabel={ inputObj.overlapLabel || defaultOverlapLabel }
                  dataIndex={ index }
                  maxLength={ 3 }
                  disabled={ inputObj.isDisabled }
                  FormGroupClassName={'number-field'}
                  handleBlurAction={ handleBlurAction }
                  type={ 'tel' }
                />
            </div>
          )
        })
      }

    </div>
  )
};


Region.propTypes = {
  content: PropTypes.object.isRequired,
  onChangeAction: PropTypes.func,
  onInputChangeAction: PropTypes.func,
  handleBlurAction:PropTypes.func
};

Region.defaultProps = {
  content: {}
};

export default Region;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/Region/index.js